<template>
  <div>
    <div class="d-flex justify-content-between"
      style="margin-bottom: 1rem;"
    >
      <button class="btn btn-sm btn-primary"
        @click="$emit('openGeneralUploadModal')"
        style="margin-bottom: 6px;"
      >
        <i class="fa fa-images"></i>
        Upload Pictures
      </button>
      <button class="btn btn-sm btn-primary"
        @click="$emit('openGeneralFolderModal')"
        style="margin-bottom: 6px;"
      >
        <i class="fa fa-folder"></i>
        Folders
      </button>
    </div>
    <folder-row
      :folders="generalDocumentsFolders"
      @openGeneralUploadModal="$emit('openGeneralUploadModal', $event)"
    />
    <document-gallary
      :documents="generalDocuments"
      rowClass="col-sm-3"
      @deleteImage="deleteImage"
      :show-drag="true"
    />
    <p v-if="! generalDocuments.length"
      style="margin-top: 8px;"
    >
      No pictures uploaded
    </p>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
      }
    },
    computed: {
      ...mapState(['generalDocuments', 'generalDocumentsFolders']),
    },
    methods: {
      deleteImage(doc) {
        if (confirm('Do you really want to delete this image?')) {
          window.axios.delete(`/documents/${doc}`).then(({data}) => {
            window.notification.success(`Image has been deleted`, 'Success!')
            this.$store.commit('removeGeneralDocument', doc)
          })
        }
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/GeneralStorePictures.vue